import {pluralize} from "@pg-mono/string-utils";

import {IHouseInvestmentBooster} from "../../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";

export const houseInvestmentGarageBooster: IHouseInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Garage,

    isValid(params) {
        return areOfferLeftPropertiesStatsValid(params.offer.stats?.building_parameters_stats?.properties_with_garage);
    },

    getSegments(params) {
        const stats = params.offer.stats?.building_parameters_stats?.properties_with_garage;

        if (!stats || !stats.left) {
            return null;
        }

        const leftTextPluralize = pluralize(["został ostatni", `zostały ostatnie ${stats.left}`, `zostało ${stats.left} ostatnich`])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${leftTextPluralize}`
            },
            pluralize(["garaż", "garaże", "garaży"])(stats.left)
        ];
    }
};
import {pluralize} from "@pg-mono/string-utils";

import {IHouseInvestmentBooster} from "../../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";

export const houseInvestmentGarageBooster: IHouseInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Garage,

    isValid(params) {
        return areOfferLeftPropertiesStatsValid(params.offer.stats?.building_parameters_stats?.properties_with_garage);
    },

    getSegments(params) {
        const stats = params.offer.stats?.building_parameters_stats?.properties_with_garage;

        if (!stats || !stats.left) {
            return null;
        }

        const leftTextPluralize = pluralize(["został ostatni", `zostały ostatnie ${stats.left}`, `zostało ${stats.left} ostatnich`])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${leftTextPluralize}`
            },
            pluralize(["garaż", "garaże", "garaży"])(stats.left)
        ];
    }
};
